import {useEventListener, useInjection} from "@dp-instant/ui";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial, IUser} from "@dp-instant/social";
import {GameModel} from "@game/coregame/model/GameModel";
import {GameEvents} from "@game/coregame/GameEvents";
import {TypesGame} from "@game/TypesGame";
import {BackButton} from "@game/ui/components/BackButton/BackButton";
import {LeaderBoardTabs} from "@game/ui/components/LeaderboardTabs/LeaderBoardTabs";
import {CoinsIndicator} from "@game/ui/components/CoinsIndicator/CoinsIndicator";
import {StarsIndicator} from "@game/ui/components/StarsIndicator/StarsIndicator";
import {ILeaderboardProps} from "@game/ui/interface/ILeaderBoardProps";
import {apiClient} from "@game/api/ApiClient";
import cn from "classnames";
import {useState, useEffect} from "preact/hooks";
import "./LeaderboardScreen.less";

export const LeaderboardScreen = (props: ILeaderboardProps) => {
    const model = useInjection<GameModel>(TypesGame.model);
    const social: ISocial = useInjection(TypesSocial.model);

    const initialState = {
        coins: model.cookie.coins,
        startCoins: model.cookie.coins
    };

    const [state, setState] = useState(() => initialState);

    useEffect(() => { if (__SOCIAL__ === "tg") apiClient.trackFunnelEvent("leaderboard_opened"); }, []);

    //remove it in other branch
    useEventListener(GameEvents.COINS_UPDATED, (data: {coins: number}) => {
        setState(state => ({...state, ...data}));
    });

    return (
        <div className={cn("screen", "screen__leaderboard")}>
            <div className={cn("screen-top", "visible")}>
                <div className={cn("container", "top-bar")}>
                    <BackButton
                        onClick={() => {
                            model.goToLobby();
                        }}
                    />
                    <div className="top-bar__currencies">
                        <CoinsIndicator
                            className={cn("coins-indicator", "coins-indicator_filled")}
                            total={model.cookie.coins}
                        />
                        {__SOCIAL__ === "tg" && (
                            <StarsIndicator
                                className={cn("stars-indicator", "stars-indicator_filled")}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className="leaderboard-content">
                <LeaderBoardTabs
                    activeTab={0}
                    className="leaderboards-tabs"
                    leaderboardsProps={props}
                />
            </div>
        </div>
    );
};
